export default function () {
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/resources/mounted.js